import React from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import { isMenuOpen } from "state/app/selectors";

import InfoButton from "components/app/bar/InfoButton";
import BasketButton from "components/school_money/BasketButton";

import "./Context.css";

/**
 * Renders the contextual button in the app bar (if any)
 * This is (currently) either the Info button or the Basket button
 * Transitions are applied between different buttons
 */
class Context extends React.Component {
  
  render() {
    
    const { location, isMenuOpen } = this.props;
    
    // state key for InfoButton is whether menu is open
    const infoButtonKey = `menu:${isMenuOpen}`;
    // state key for route-based button is derived from location
    // WARNING: this assumes that the button only and always changes
    //   when the top-level part of the path changes (e.g. the product)
    const routeButtonKey = `route:${location.hash.split("/")[1]}`;
    
    return (
      <div className="app-bar__context">
        <TransitionGroup>
          {
            isMenuOpen ?
            <CSSTransition key={infoButtonKey} classNames="app-bar__context-item" timeout={200}>
              <InfoButton />
            </CSSTransition> :
            <CSSTransition key={routeButtonKey} classNames="app-bar__context-item" timeout={200} in={!this.props.isMenuOpen}>
              <Switch location={location}>
                <Route path="/school_money/" component={BasketButton} />
              </Switch>
            </CSSTransition>
          }
        </TransitionGroup>
      </div>
    );
    
  }
  
}

export default connect(
  state => ({
    isMenuOpen: isMenuOpen(state)
  })
)(Context);



// WEBPACK FOOTER //
// ./src/components/app/bar/Context.js